<template lang="pug">
.cart-item.gift-card-item
  .summary__line
    .summary__prod.summary__prod--left
      p {{ item.attributes.product.title }}
      p.summary__time.hidden
      p.summary_time-hide
      a.summary_delete-hide.summary__edit(href='#' @click.prevent="itemDelete($event)") DELETE
    .summary__prod
      p -
    .summary__prod
      p.summary__price-sp.nowrap {{ item.attributes.product.price | currency }}
      p.summary__subtotal-price-hide.nowrap {{ (item.total * 1) + (item.attributes.product.tax_amount * item.payload.count) | currency }}
      .summary__calc
        p.nowrap {{ item.payload.count }}
    .summary__prod.summary__price
      p.nowrap {{ item.attributes.product.price | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.price * item.payload.count | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.tax * item.payload.count | currency }}
    .summary__prod.summary__prod--right.summary__prod--last
      p.nowrap {{ (Number(item.attributes.product.price) + Number(item.attributes.product.tax)) * item.payload.count | currency }}
      button.summary__remove-product(@click.prevent="itemDelete($event)")
</template>

<script>
const EventBus = window.VueEventBus
import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import DatesMixin from '../../components/_mixins/dates'
import GiftCardMixin from '../../components/_mixins/giftcard'

export default {
  name: 'free-promo-linked-gift-cards-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    DatesMixin,
    GiftCardMixin
  ],

  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },

  created() {
    EventBus.$on('cart.item.updated', item => {
      if (item.type == 'gift_cards' && item.id == this.item.promo_item_id) {
        if (item.payload.count != this.item.payload.count) {
          this.setCount(item.payload.count)
        }
      }
    })

    EventBus.$on('cart.item.removed', item => {
      if (item.type == 'gift_cards' && item.id == this.item.promo_item_id) {
        if (!Object.values(this.currentCartItems).some(x => x.type == this.item.type && x.payload.product_id == this.item.payload.product_id && x.id != this.item.id)) {
          const coupon = window.addiesaas.active_promo_coupons.find(c => c.condition_products.map(x => Number(x)).includes(item.payload.product_id))
          const discount = Object.values(this.cartDiscounts).find(x => x.payload.options.code == coupon.code)
          this.removeCartDiscount(discount)
        }
        this.itemDelete(null)
      }
    })
  },

  methods: {
    itemDelete($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: this.item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },

    setCount(count) {
      EventBus.$emit('cart.validating', true)
      this.setCartItemCount({ id: this.item.id, count })
      EventBus.$$emitAsync('cart.validate')
      EventBus.$emit('cart.validating', false)
    },
  }
}

EventBus.$on('cart.item.added', async (item) => {
  if (item.type == 'gift_cards') {
    const store = window.addiesaas.store

    Object.values(store.getters['Shop/Orders/Cart/cartItems'])
      .filter(i => 'promo_item_id' in i && i.promo_item_id == item.id)
      .forEach(i => {
        store.dispatch('Shop/Orders/Cart/removeCartItem', i)

        const couponItems = Object.values(store.getters['Shop/Orders/Cart/cartItems'])
          .some(x => x.type == i.type && x.coupon_code == i.coupon_code)
        if (!couponItems) {
          const discount = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
            .find(x => x.payload.options.code == i.coupon_code)
          store.dispatch('Shop/Orders/Cart/removeCartDiscount', discount)
        }
      })

    const coupons = window.addiesaas.active_promo_coupons
    const coupon = coupons.find(c => c.condition_products.map(x => Number(x)).includes(item.payload.product_id))
    if (coupon) {
      const products = _.flatMap(window.addiesaas.products.types)
      const product = products.find(x => x.id == coupon.free_product_id)
      const store = window.addiesaas.store
      const code = coupon.code

      await store.dispatch('Shop/Orders/Cart/addCartItem', {
        type: 'free-promo-linked-gift-cards',
        total: product.price,
        count: item.payload.count,
        payload: {
          product_id: coupon.free_product_id,
          count: item.payload.count,
          options: {
            recipient_email: null,
          },
        },
        editable: false,
        attributes: {
          product,
        },
        promo_item_id: item.id,
        coupon_code: code,
      })

      const isPromoCouponAdded = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
        .some(discount => discount.payload.type == 'coupon' && discount.payload.options.code == code)
      if (!isPromoCouponAdded) {
        await store.dispatch('Shop/Orders/Cart/addDiscount', {
          title: code,
          type: 'coupon',
          payload: {
            type: 'coupon',
            options: {
              code,
            },
          },
        })
      }
    }
  }
})

EventBus.$on('cart.validate.before', () => {
  const store = window.addiesaas.store
  const activePromoCoupons = window.addiesaas.active_promo_coupons
  const promoCoupons = window.addiesaas.promo_coupons
  Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
    .filter(discount => discount.type == 'coupon')
    .forEach(discount => {
      const code = discount.payload.options.code
      if (promoCoupons.includes(code) && !activePromoCoupons.some(c => c.code == code)) {
        Object.values(store.getters['Shop/Orders/Cart/cartItems'])
          .filter(item => item.coupon_code == code)
          .forEach(item => {
            store.dispatch('Shop/Orders/Cart/removeCartItem', item)
            store.dispatch('Shop/Orders/Cart/removeCartItem', { id: item.promo_item_id })
          })
        store.dispatch('Shop/Orders/Cart/removeCartDiscount', discount)
      }
    })
})

</script>
